import { useState } from 'react';

import { t } from '../i18n';
import { EMOJI_DATA, emojiChoices } from './emoji';

export function EmojiPicker({ onPick }: { onPick: (emoji: string) => void }): React.ReactElement {
  const [query, setQuery] = useState('');
  const [tab, setTab] = useState(0);
  const choices = emojiChoices(query, tab);
  const searching = query.trim().length > 0;

  return (
    <>
      <input
        className="picker__search"
        value={query}
        placeholder={t('page.icon.search')}
        aria-label={t('page.icon.search')}
        onChange={(event) => setQuery(event.target.value)}
      />
      {searching ? null : (
        <div className="picker__cats">
          {EMOJI_DATA.map((category, index) => (
            <button
              key={category[0]}
              type="button"
              className={index === tab ? 'picker__cat is-on nb' : 'picker__cat nb'}
              title={category[0]}
              aria-label={category[0]}
              onClick={() => setTab(index)}
            >
              {category[1][0]?.[0]}
            </button>
          ))}
        </div>
      )}
      {choices.length === 0 ? (
        <p className="picker__empty">{t('page.icon.empty')}</p>
      ) : (
        <div className="picker__grid">
          {choices.map((entry) => (
            <button
              key={`${entry[0]}-${entry[1]}`}
              type="button"
              className="picker__emoji nb"
              title={entry[1]}
              aria-label={entry[1]}
              onClick={() => onPick(entry[0])}
            >
              {entry[0]}
            </button>
          ))}
        </div>
      )}
    </>
  );
}
